module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/icon-5b3fe33bee530b840745b208f5134f0c.png";